/* eslint-disable lingui/no-unlocalized-strings -- nomes de recurso, tipo e ação do fio, não texto de UI */
/** Código numérico do tipo → nome, como `PermissionTypes` do legado (Enum/PermissionType.ts). */
export const PERMISSION_TYPES: Readonly<Record<number, string>> = {
  0: 'Read',
  1: 'Create',
  2: 'Update',
  3: 'Delete',
  4: 'SubmitApproval',
  5: 'ComplianceApproval',
  6: 'CreditApproval',
  7: 'InstrumentApproval',
  8: 'LiquidationApproval',
  9: 'LiquidationPaymentRevision',
  10: 'Clone',
  11: 'UploadDocs',
  12: 'DraftPreview',
  13: 'AssigmentPreview',
  14: 'SendAssigmentEmail',
  15: 'ManualUpdate',
  16: 'RemoveBlock',
  17: 'SignatureValidation',
  18: 'RegisterFgtsSaqueAniversario',
  19: 'Cancel',
  20: 'AssignRecord',
  21: 'SendNotification',
  22: 'RestoreRecord',
  23: 'ReadDataSet',
  24: 'RequestDataSet',
  25: 'SetFund',
  26: 'SendToWedCred',
  27: 'FinishSignature',
  28: 'RequestNewOperator',
  29: 'ViewPendingOperators',
  30: 'AdminApproveOperator',
  31: 'AdminCancel',
  32: 'ViewOperators',
  33: 'OpenBankAccount',
  34: 'ApproveBankAccountLimit',
  35: 'RequestBankAccountLimit',
  36: 'AdminApproveBeneficiary',
  37: 'ViewPendingApprovals',
  38: 'SimulateAmortization',
  39: 'ViewAllBankAccounts',
  40: 'MasterApproverAllBankAccounts',
  41: 'AddAccountEntry',
  42: 'StartSignatureWorkFlow',
  43: 'CancelSignatureWorkFlow',
  44: 'ResendNotificationSignatureWorkFlow',
  45: 'EnableUser',
  46: 'DisableUser',
  47: 'AllowUpdatePermissionsSameTenant',
  48: 'ApproveWarranty',
  49: 'ApproveMarginReserve',
  50: 'RestartWorkflow',
  51: 'TerminateAccount',
  52: 'IncludeBeneficiaryProduct',
  53: 'UpdateBillingCosts',
  54: 'ApproveWarrantyRevision',
  55: 'UpdateTenantExtensions',
  56: 'SendToWalletManagement',
  57: 'TenantDataQueryAuthorization',
  58: 'UY3AccessToFrontWebSPI',
  59: 'PixMed',
  60: 'ManageAutomaticDebit',
  61: 'BatchAssignmentApprove',
  62: 'RegisterRules',
  63: 'AuctionQuery',
  64: 'CreditNoteOpInsurance',
  65: 'ViewTransitoryAccount',
  66: 'ReactivateAccount',
  67: 'VehicleInspectionApproval',
  68: 'EditRelatedOperationLink',
  69: 'TenantInssMarginAuthorization',
  70: 'BaseOffEligibilityQuery',
  71: 'Write',
  72: 'Publish',
  73: 'AuctionNotEligibleQuery',
};

/** Nível CRUD pelo índice que a API manda (0–3). Ação é booleana: só `All` concede. */
export const PERMISSION_LEVELS = ['None', 'OnlyMine', 'MyGroups', 'All'] as const;
export type PermissionLevel = (typeof PERMISSION_LEVELS)[number];

export type CrudType = 'Read' | 'Create' | 'Update' | 'Delete';

/** Recursos do legado (Enum/PermissionResource.ts), pelo nome que a API devolve em `resourceDisplay`. */
export type PermissionResource =
  | 'CreditNote'
  | 'User'
  | 'UserGroup'
  | 'UserApplication'
  | 'ResourceServer'
  | 'BankAccount'
  | 'BankAccountRequest'
  | 'LegalPerson'
  | 'NaturalPerson'
  | 'Person'
  | 'Permission'
  | 'Fund'
  | 'CreditProduct'
  | 'BankAccountProduct'
  | 'BatchAssignment'
  | 'PendingApprovals'
  | 'SignatureWorkFlow'
  | 'BillingAccount'
  | 'InsuranceProduct'
  | 'BillingProduct'
  | 'BillingWallet'
  | 'TenantRequest'
  | 'Device'
  | 'ManagePayrollAgreementSettings'
  | 'DataQueryAuthorization'
  | 'InssMarginAuthorization'
  | 'FrontWebSPI'
  | 'ChatbotSupport'
  | 'PixMed'
  | 'Conciliation'
  | 'CreditProductRules'
  | 'DimensaSubmission'
  | 'CreditRecovery'
  | 'AgentConversation'
  | 'AgentAudit'
  | 'AgentTool'
  | 'AgentPrompt'
  | 'AgentDefinition'
  | 'AgentOrchestration';

/** Tipo pedido na checagem: CRUD, nome de ação ou chave cruzada `Recurso:Tipo`. */
export type PermissionType = CrudType | (string & {});
